/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential.
 *
 * Audit batch H18 (owner 16/10/2026): the pipeline offers Delete only where the
 * server would delete. api/delete-session.js refuses a case with any recorded
 * document, so a case with documents (an invitation created with documents, or
 * a documents first client who has uploaded) is offered Archive instead.
 */
export const UNTOUCHED_STATUSES = Object.freeze(['invited', 'preparing', 'sent', 'in_progress']);

// The pipeline rows whose documents are worth looking up (the rest are Archive anyway).
export function deleteCandidates(rows) {
  return (rows || []).filter(s => s && UNTOUCHED_STATUSES.includes(s.status) && !s.report).map(s => s.id);
}

/** 'delete' or 'archive' for a pipeline row. withDocuments: a Set of case ids with a recorded document. */
export function removeActionFor(row, withDocuments) {
  if (!row || !UNTOUCHED_STATUSES.includes(row.status) || row.report) return 'archive';
  const cd = row.collected_data || {};
  if (cd.prefiled === true) return 'archive';
  if (!withDocuments || withDocuments.has(row.id)) return 'archive';
  return 'delete';
}
